define.alias("ember-math-helpers/helpers/log10", "preview-grid/helpers/log10");